import React, { useState } from 'react';
import '../../../styles/v4-theme.css';

/**
 * RawJsonTab Component
 * Displays the raw JSON data with syntax highlighting and copy functionality
 */
const RawJsonTab = ({ target }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const jsonString = JSON.stringify(target, null, 2);
    navigator.clipboard.writeText(jsonString).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const jsonString = JSON.stringify(target, null, 2);

  return (
    <div className="v4-raw-json-content" style={{ padding: 'var(--space-3)', position: 'relative' }}>
      {/* Header with controls */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 'var(--space-4)'
      }}>
        <h3 className="v4-heading-3">
          {'{}'} RAW JSON DATA
        </h3>
        <button
          onClick={handleCopy}
          style={{
            padding: 'var(--space-2) var(--space-4)',
            background: copied ? 'var(--confidence-high)' : 'var(--accent)',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: 'var(--text-sm)',
            fontWeight: 'var(--font-semibold)',
            cursor: 'pointer',
            transition: 'all var(--transition-base)',
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--space-2)'
          }}
        >
          {copied ? (
            <>
              <span>✓</span>
              <span>Copied!</span>
            </>
          ) : (
            <>
              <span>📋</span>
              <span>Copy JSON</span>
            </>
          )}
        </button>
      </div>

      {/* JSON Display */}
      <div style={{
        background: 'var(--bg-secondary)',
        border: '1px solid var(--border)',
        borderRadius: '8px',
        padding: 'var(--space-4)',
        overflow: 'visible',
        maxHeight: 'none'
      }}>
        <pre style={{
          margin: 0,
          fontFamily: "'Consolas', 'Monaco', 'Courier New', monospace",
          fontSize: 'var(--text-sm)',
          lineHeight: '1.6',
          color: 'var(--text-primary)',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word'
        }}>
          {jsonString}
        </pre>
      </div>

      {/* Metadata */}
      <div style={{
        marginTop: 'var(--space-4)',
        padding: 'var(--space-3)',
        background: 'var(--bg-card)',
        borderRadius: '6px',
        fontSize: 'var(--text-sm)',
        color: 'var(--text-secondary)'
      }}>
        <div>Target ID: <span style={{ color: 'var(--text-primary)', fontFamily: 'monospace' }}>{target.id}</span></div>
        <div>Type: <span style={{ color: 'var(--text-primary)' }}>{target.type}</span></div>
        <div>Size: <span style={{ color: 'var(--text-primary)' }}>{(jsonString.length / 1024).toFixed(2)} KB</span></div>
      </div>

      {/* Help Text */}
      <div style={{
        marginTop: 'var(--space-4)',
        padding: 'var(--space-3)',
        background: 'rgba(124, 58, 237, 0.1)',
        border: '1px solid var(--accent)',
        borderRadius: '6px',
        fontSize: 'var(--text-sm)',
        color: 'var(--text-secondary)'
      }}>
        <strong style={{ color: 'var(--accent)' }}>💡 Tip:</strong> This is the complete raw data structure for this target. 
        All fields extracted by the AI are visible here, even if they're not shown in the organized tabs above.
      </div>
    </div>
  );
};

export default RawJsonTab;

